import React, { Component } from 'react';
import OtpCodeValidationModal from './OtpCodeValidationModal';
import AlertTransferences from './alertTransferences';
import ErrorModal from '../../../../../components/ErrorModal/ErrorModal';
import InputButton from '../../../../../components/ZUILib/InputButton';
import commonUtil from '../../../../../utils/commonUtil';
import { authenticateOTP, searchOtpUser, createOtpUser, createOtpDevice, createOtpCode, validateOtpCode } from '../../actions';

class OtpCode extends Component {
  constructor(props) {
    super(props);
    this.channel = commonUtil.getChannel();
    this.constChannels = commonUtil.getClientConstForChannel();
    this.otpTokenAuthentication = null;
    this.state = {
      email: null,
      phoneNumber: null,
      titleError: null,
      bodyError: null,
      btnSendOtpDisabled: true,
    };
  }

  componentDidMount = () => {
    if (this.channel === this.constChannels.WAP) { this.OtpCodeValidationModal.initTimeWap(); }
    this.initOTPAuthenticate();
  }

  initOTPAuthenticate = async () => {
    const userName = commonUtil.getLabel(
      this.props.lables['Retiro Anticipado Landing Page'],
      'otp.authenticate.userName'
    );
    const response = await authenticateOTP(userName);
    if (response.body.token) {
      this.otpTokenAuthentication = response.body.token;
      this.searchOtpUser();
    }
  }

  searchOtpUser = async () => {
    try {
    const response = await searchOtpUser(this.props.user.profileId, this.otpTokenAuthentication);
    if (response.body.status.status === "success" && response.body.statusCode === 200) {
      this.createOtpDevice();
    } else if (response.body.statusCode === 404) {
      this.createOtpUser();
    } else if (response.body.statusCode === 409) {
      this.setState({ titleError: 'Límite de solicitudes excedido', bodyError: response.body.message, btnSendOtpDisabled: true });
      this.ErrorModal.handleShow();
    } else { this.ErrorModal.handleShow(); }
    } catch (error) {
      if ((error.body.statusCode === 404)) {
        this.createOtpUser();
      } else if (error.body.statusCode === 409) {
        this.setState({ titleError: 'Límite de solicitudes excedido', bodyError: error.body.message, btnSendOtpDisabled: true });
        this.ErrorModal.handleShow();
      } else { this.ErrorModal.handleShow(); }
    }
  }

  createOtpUser = async () => {
    try {
    const response = await createOtpUser(this.props.user.profileId, this.otpTokenAuthentication);
    if (response.body.status.status === 'success' && (response.body.statusCode === 201 || response.body.statusCode === 200)) {
      this.createOtpDevice();
    } else { this.ErrorModal.handleShow(); }
    } catch (error) {
      this.ErrorModal.handleShow();
    }
  }

  isDeviceAlreadyExistsError = (payload) => {
    if (!payload) return false;
    const nested = payload.data || {};
    const code = payload.errorCode || nested.status || payload.statusCode;
    const message = payload.errorMessage || nested.detail || payload.detail;
    return Boolean(
      code && String(code).includes('409') &&
      message && String(message).includes('already exists')
    );
  }

  createOtpDevice = async () => {
    try {
    const response = await createOtpDevice(this.props.user.profileId, this.otpTokenAuthentication);
    if (
      (response.body.status.status === 'success' &&
        (response.body.statusCode === 201 ||
          response.body.statusCode === 200)) ||
      this.isDeviceAlreadyExistsError(response.body)
    ) {
      this.otpCreateCode();
    } else {
      this.ErrorModal.handleShow();
    }
    } catch (error) {
      if (this.isDeviceAlreadyExistsError(error.body)) {
        this.otpCreateCode();
      } else {
        this.ErrorModal.handleShow();
      }
    }
  }

  otpCreateCode = async () => {
    try {
    const response = await createOtpCode(this.props.user.profileId, this.props.eventId, this.otpTokenAuthentication);
    if (response.body.status.status === 'success' && response.body.statusCode === 200) {
      this.setState({ email: response.body.email, phoneNumber: response.body.phoneNumber, btnSendOtpDisabled: false });
      this.openOtpCodeModal();
    } else if ((response.body.statusCode === 409) || (response.body.statusCode === 424)) {
      this.setState({ titleError: 'Límite de solicitudes excedido', bodyError: response.body.message, btnSendOtpDisabled: true });
      this.OtpCodeValidationModal.handleClose();
      this.ErrorModal.handleShow();
    } else { this.ErrorModal.handleShow(); }
    } catch (error) {
      if ((error.body.statusCode === 409) || (error.body.statusCode === 424)) {
        this.setState({ titleError: 'Límite de solicitudes excedido', bodyError: error.body.message, btnSendOtpDisabled: true });
      }
      this.ErrorModal.handleShow();
    }
  }

  validateOtpCode = async (otpCode) => {
    try {
      const response = await validateOtpCode(this.props.user.profileId, otpCode, this.otpTokenAuthentication);
      if (response.body.status.status === 'success' && response.body.statusCode === 200) {
        return { success: true, message: '' };
      } else if (response.body.statusCode === 409 && response.body.availableAttempts === '0') {
        this.setState({ titleError: 'Límite de intentos excedido', bodyError: response.body.message, btnSendOtpDisabled: false });
        this.OtpCodeValidationModal.handleClose();
        this.ErrorModal.handleShow();
      }
      return { success: false, message: response.body.message };
    } catch (error) {
      const message = error?.body?.detail;
      return { success: false, message };
    }
  };

  openOtpCodeModal = async () => {
    this.OtpCodeValidationModal.handleShow();
  }

  backPage = () => { this.props.nextPage(2); }

  backPageWap = () => { this.props.backPageWap(); }

  render() {
    const channel = commonUtil.getChannel();
    const constChannels = commonUtil.getClientConstForChannel();
    const isWap = channel === constChannels.WAP;
    const isPartial = this.props.type === 'partial';
    const alertContainer = {
      border: '1px solid #ADA8A8',
      borderRadius: '20px',
      paddingTop: isPartial ? null : '1%',
    };
    const backButton = {
      name: 'backButton',
      type: 'button',
      value: 'Regresar',
      autoFocus: false,
      cssStyle: {
        borderRadius: '4px',
      },
      style: 'btnSecondaryAction size-Large',
      onClickHandler: this.backPage,
    };
    return (
      <React.Fragment>
        {
          !isWap ?
            <React.Fragment>
              <div className="panel-heading row" style={{ margin: '5%' }}>
                <div style={alertContainer}>
                  { isPartial && <AlertTransferences /> }
                  <h3 style={{ marginLeft: '10px' }}>Verificación de seguridad</h3>
                  <div className="row show-grid-row" style={{ textAlign: 'center' }}>
                    <div className="row col-xs-12" style={{ margin: '40px 0 30px 0' }}>
                      <p>
                        Para confirmar el {this.props.type === 'closure' ? ' cierre ' : ' retiro '}
                        <span style={{ fontWeight: '600' }}>te enviaremos un código de seguridad a tu correo electrónico y a tu número de celular.</span>
                      </p>
                      <button
                        className="btnPrimarySpecial size-Large"
                        style={{ margin: '2rem 0', borderRadius: '4px', width: '20%' , color:'var(--main-color-brand)' ,borderColor:'var(--main-color-brand)' }}
                        disabled={this.state.btnSendOtpDisabled}
                        onClick={this.openOtpCodeModal}
                      >
                        Enviar código de seguridad
                      </button>
                      <p>
                        Al ingresar el código, <span style={{ fontWeight: '600' }}> no habrá posibilidad de cambios.</span>
                      </p>
                    </div>
                  </div>
                </div>
                <div className="row block-buttons">
                  <div className="col-xs-6">
                    <InputButton buttonAttr={backButton} />
                  </div>
                </div>
              </div>
              <OtpCodeValidationModal
                onRef={ref => (this.OtpCodeValidationModal = ref)}
                user={this.props.user}
                email={this.state.email}
                phoneNumber={this.state.phoneNumber}
                submitTransferenceData={this.props}
                eventId={this.props.eventId}
                type={this.props.type}
                validateOtp={this.validateOtpCode}
                createOtp={this.otpCreateCode}
              />
            </React.Fragment> :
            <OtpCodeValidationModal
              onRef={ref => (this.OtpCodeValidationModal = ref)}
              user={this.props.user}
              email={this.state.email}
              phoneNumber={this.state.phoneNumber}
              submitTransferenceData={this.props}
              eventId={this.props.eventId}
              type={this.props.type}
              validateOtp={this.validateOtpCode}
              createOtp={this.otpCreateCode}
            />
        }
        <ErrorModal
          onRef={ref => (this.ErrorModal = ref)}
          eventId={this.props.eventId}
          titleError={this.state.titleError}
          bodyError={this.state.bodyError}
          setGiftListTransferenceStatementTab={this.props.setGiftListTransferenceStatementTab}
        />
      </React.Fragment>
    );
  }
}

export default OtpCode;
